import { render, staticRenderFns } from "./RewardResult.vue?vue&type=template&id=c3e1242a&scoped=true"
import script from "./RewardResult.vue?vue&type=script&lang=js"
export * from "./RewardResult.vue?vue&type=script&lang=js"
import style0 from "./RewardResult.vue?vue&type=style&index=0&id=c3e1242a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e1242a",
  null
  
)

export default component.exports